import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { motion } from 'framer-motion';

const HeaderDashboard = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <motion.header
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1, ease: 'easeOut' }}
      className="dashboard-element-bg header-area header-sticky fixed w-full top-0 z-50 px-4 py-2 md:px-6 lg:px-8"
    >
      <div className="container mx-auto flex justify-between items-center">
        <RouterLink to="/" className="">
          <img 
            className="h-12 sm:h-120 md:h-20 lg:h-24 object-contain transition-all duration-200" 
            src="/assets/images/joltchat_logo_white.png" 
            alt="JoltChat Logo" 
          />
        </RouterLink>

        {/* Mobile Menu Button */}
        {/* <button 
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="md:hidden p-2"
        >
          <svg 
            className="w-6 h-6 text-white"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            {isMenuOpen ? (
              <path d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button> */}

        {/* Navigation */}
        <nav className={`
          absolute md:relative
          top-full left-0 w-full md:w-auto
          bg-gray-800 md:bg-transparent
          ${isMenuOpen ? 'block' : 'hidden'} md:block
          transition-all duration-200
        `}>
          <ul className="nav flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4 p-4 md:p-0">
            {/* Navigation Items */}
          </ul>
        </nav>
      </div>
    </motion.header>
  );
};

export default HeaderDashboard;